<div class="page-wrap contact-us">
    <div class="homeSlider">
        <div class="item">
        <img src="assets/images/slide1.jpg" alt="banner">
        </div>
    </div>
    <div class="container">
        <div class="row mb-5 row-flex">
            <div class="col-12 col-md-4 col-lg-4">
                <div class="covers">
                    <h4 class="hdx"><span>Contact Us</span></h4>
                    <div class="page-content">
                        <div class="row">
                            <div class="col-12 col-md-12">
                                <!-- <h5>Address1</h5> -->
                                <p>
                                    <strong>Immunization Division</strong>,<br/> Ministry of Health and Family Welfare,<br/> Near Udyog Bhawan Metro Station, <br/>Maulana Azad Rd,<br/> New Delhi,<br/> Delhi 110011
                                </p>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
            <div class="col-12 col-md-8 col-lg-8">
                <div class="covers">
                <div class="page-content">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1751.3164400475678!2d77.21305830800075!3d28.6107883503002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce2b834500e75%3A0xcf0479b94060c647!2sMinistry%20of%20Health%20%26%20Family%20Welfare%2C%20Nirman%20Bhawan!5e0!3m2!1sen!2sin!4v1610112869708!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>

